<template>
    <div class="title-box">
        <div class="title">
            <img class="title-left-icon" :data-src="'../static/img/' + type + '-left-icon.png'" alt="">
            <div class="middle-text" :style="type == 'white' ? 'color: #fff;font-size:' + size + 'vw' : 'font-size:' + size + 'vw'">{{english}}</div>
            <img class="title-right-icon" :data-src="'../static/img/' + type + '-right-icon.png'" alt="">
            <div class="title-position" :style="type == 'white' ? 'color: #fff' : ''">{{title}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'mt-title',
    props: {
        title: {
            type: String,
            value: ''
        },
        english: {
            type: String,
            value: ''
        },
        type: {
            type: String,
            value: 'blue'
        },
        size: {
            type: Number,
            value: 7
        }
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
.title-box{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 13vw auto 8vw;
}
.title{
    height: 4.2vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
.title-left-icon,.title-right-icon{
    width: 12vw;
}
.middle-text{
    text-align: center;
    font-family: Arial;
    font-weight: bold;
    color: #4468E6;
    opacity: 0.25;
    padding: 0 2vw;
    white-space: nowrap;
}
.title-position{
    position: absolute;
    font-size: 5vw;
    color: #2B2E48;
    font-family: PingFang SC;
    font-weight: bold;
    top: -4vw;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/Mt-title.vue